export const FLOW = 'FLOW';
export const IMX = 'IMX';
export const ETH = 'ETH';
export const WAX = 'WAX';
